class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 500)),
      this.querySelector("form").addEventListener(
        "input",
        this.debouncedOnSubmit.bind(this)
      );
    if (Array.from(this.classList).includes("mobile-sort-by")) {
      this.handleMobileSort();
    }
  }
  static setListeners() {
    window.addEventListener("popstate", (e) => {
      const t = e.state
        ? e.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev &&
        FacetFiltersForm.renderPage(t, null, !1);
    });
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll(".js-facet-remove").forEach((t) => {
      t.classList.toggle("disabled", e);
    });
  }
  static renderPage(e, t, r = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    const i = FacetFiltersForm.getSections(),
      a = document.getElementById("ProductCount"),
      s = document.getElementById("ProductCountDesktop");
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading"),
      a && a.classList.add("loading"),
      s && s.classList.add("loading"),
      i.forEach((r) => {
        const i = `${window.location.pathname}?section_id=${r.section}&${e}`,
          a = (e) => e.url === i;
        FacetFiltersForm.filterData.some(a)
          ? FacetFiltersForm.renderSectionFromCache(a, t)
          : FacetFiltersForm.renderSectionFromFetch(i, t);
      }),
      r && FacetFiltersForm.updateURLHash(e);
  }
  static renderSectionFromFetch(e, t) {
    fetch(e)
      .then((e) => e.text())
      .then((r) => {
        const i = r;
        (FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html: i, url: e },
        ]),
          FacetFiltersForm.renderFilters(i, t),
          FacetFiltersForm.renderProductGridContainer(i),
          FacetFiltersForm.renderProductCount(i),
          "function" == typeof initializeScrollAnimationTrigger &&
          initializeScrollAnimationTrigger(i.innerHTML);
      });
  }
  static renderSectionFromCache(e, t) {
    const r = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(r, t),
      FacetFiltersForm.renderProductGridContainer(r),
      FacetFiltersForm.renderProductCount(r),
      "function" == typeof initializeScrollAnimationTrigger &&
      initializeScrollAnimationTrigger(r.innerHTML);
  }
  static renderProductGridContainer(e) {
    (document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("ProductGridContainer").innerHTML),
      document
        .getElementById("ProductGridContainer")
        .querySelectorAll(".scroll-trigger")
        .forEach((e) => {
          e.classList.add("scroll-trigger--cancel");
        });
  }
  static renderProductCount(e) {
    const t = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("ProductCount").innerHTML,
      r = document.getElementById("ProductCount"),
      i = document.getElementById("ProductCountDesktop");
    r.innerHTML = t;
    r.classList.remove("loading");
    i.classList.remove("loading");
    if (i) {
      if (i.innerHTML.includes("Designs")) {
        i.innerHTML =
          i.innerHTML.split("(")[0] + "(" + t.split(" ")[0] + " Designs)";
      } else {
        i.innerHTML = t;
      }
    }
    if (document.getElementById("collection-handle")) {
      if (
        document
          .getElementById("collection-handle")
          .innerHTML.includes("Designs")
      ) {
        document.getElementById("collection-handle").innerHTML =
          document.getElementById("collection-handle").innerHTML.split("(")[0] +
          "(" +
          t.split(" ")[0] +
          " Designs)";
      } else {
        document.getElementById("collection-handle").innerHTML = t;
      }
    }
    if (document.getElementsByClassName("view-all-prod")[0]) {
      document.getElementsByClassName("view-all-prod")[0].innerHTML =
        document
          .getElementsByClassName("view-all-prod")[0]
          .innerHTML.split("(")[0] +
        "(" +
        t.split(" ")[0] +
        ")";
    }
    if (document.getElementsByClassName("retail-view-all-prod")[0]) {
      document.getElementsByClassName("retail-view-all-prod")[0].innerHTML =
        "Apply (" + t.split(" ")[0] + ")";
    }
  }
  static renderFilters(e, t) {
    const r = new DOMParser().parseFromString(e, "text/html"),
      i = r.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
      ),
      a = (e) => {
        const r = t ? t.target.closest(".js-filter") : void 0;
        return !!r && e.dataset.index === r.dataset.index;
      },
      s = Array.from(i).filter((e) => !a(e)),
      n = Array.from(i).find(a);
    s.forEach((e) => {
      document.querySelector(
        `.js-filter[data-index="${e.dataset.index}"]`
      ).innerHTML = e.innerHTML;
    }),
      FacetFiltersForm.renderActiveFacets(r),
      FacetFiltersForm.renderAdditionalElements(r),
      n && FacetFiltersForm.renderCounts(n, t.target.closest(".js-filter"));
  }
  static renderActiveFacets(e) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
      const r = e.querySelector(t);
      r && (document.querySelector(t).innerHTML = r.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderAdditionalElements(e) {
    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(
      (t) => {
        e.querySelector(t) &&
          (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
      }
    ),
      document
        .getElementById("FacetFiltersFormMobile")
        .closest("menu-drawer")
        .bindEvents();
  }
  static renderCounts(e, t) {
    const r = t.querySelector(".facets__selected"),
      i = e.querySelector(".facets__selected"),
      a = t.querySelector(".facets__summary"),
      s = e.querySelector(".facets__summary");
    i &&
      r &&
      (t.querySelector(".facets__selected").outerHTML =
        e.querySelector(".facets__selected").outerHTML),
      a &&
      s &&
      (t.querySelector(".facets__summary").outerHTML =
        e.querySelector(".facets__summary").outerHTML);
  }
  static updateURLHash(e) {
    history.pushState(
      { searchParams: e },
      "",
      `${window.location.pathname}${e && "?".concat(e)}`
    );
  }
  static getSections() {
    return [{ section: document.getElementById("product-grid").dataset.id }];
  }
  createSearchParams(e) {
    const t = new FormData(e);
    for (let [key, value] of t.entries()) {
      if (value === "Price Check") {
        t.delete(key);
      }
    }
    const errors = this.querySelectorAll(".price-error");
    errors.forEach((e) => {
      if (
        parseInt(t.get("filter.v.price.lte")) >=
        parseInt(t.get("filter.v.price.gte"))
      ) {
        e.style.display = "none";
      }
    });
    let r = new URLSearchParams(t).toString();
    let i =
      "filter.v.price.lte=" +
      parseInt(document.querySelector(".facets__price .field__input").max);
    let a = r.split("&");
    let s = a.indexOf("filter.v.price.gte=0");
    let n = a.indexOf(i);
    if (
      parseInt(t.get("filter.v.price.lte")) <
      parseInt(t.get("filter.v.price.gte"))
    ) {
      const min = "filter.v.price.gte=" + parseInt(t.get("filter.v.price.gte"));
      i = "filter.v.price.lte=" + parseInt(t.get("filter.v.price.lte"));
      s = a.indexOf(min);
      n = a.indexOf(i);
      errors.forEach((e) => (e.style.display = "flex"));
    }
    return (
      s > -1 && n > -1 && (a.splice(s, 1), (n = a.indexOf(i)), a.splice(n, 1)),
      (r = a.join("&")),
      r
    );
  }
  handleMobileSort() {
    this.querySelector(".select").addEventListener("click", () => {
      document.querySelector("#mob_sort_by_overlay").style.display = "flex";
    });
    document.querySelector("#close-sort-by").addEventListener("click", () => {
      document.querySelector("#mob_sort_by_overlay").style.display = "none";
    });
  }
  onSubmitForm(e, t) {
    FacetFiltersForm.renderPage(e, t);
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    if (window.matchMedia("(max-width: 749px)").matches) {
      document
        .getElementsByTagName("header")[0]
        .after(document.getElementsByClassName("active-facets-mobile")[0]);
    }
  }
  onSubmitHandler(e) {
    e.preventDefault();
    const t = document.querySelectorAll("facet-filters-form form");
    if ("mobile-facets__checkbox" == e.srcElement.className) {
      const t = this.createSearchParams(e.target.closest("form"));
      this.onSubmitForm(t, e);
    } else {
      const r = [],
        i = "FacetFiltersFormMobile" === e.target.closest("form").id;
      t.forEach((e) => {
        i
          ? "FacetFiltersFormMobile" === e.id &&
          r.push(this.createSearchParams(e))
          : ("FacetSortForm" !== e.id &&
            "FacetFiltersForm" !== e.id &&
            "FacetSortDrawerForm" !== e.id) ||
          (document
            .querySelectorAll(".no-js-list")
            .forEach((e) => e.remove()),
            r.push(this.createSearchParams(e)));
      }),
        this.onSubmitForm(r.join("&"), e);
    }
  }
  onActiveFilterClick(e) {
    e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
    const t =
      -1 == e.currentTarget.href.indexOf("?")
        ? ""
        : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(t);
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define("facet-filters-form", FacetFiltersForm),
  FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector("#FacetsWrapperDesktop");
    e && e.addEventListener("keyup", onKeyUpEscape), this.initializeSlider();
    if (window.matchMedia("(max-width: 749px)").matches) {
      this.setMobilePriceCheck();
    }
  }

  setMobilePriceCheck() {
    let priceCheckboxes = this.querySelectorAll(".mobile-facets__checkbox");
    priceCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (e) => {
        e.preventDefault();
        const totalCheck = document.querySelectorAll(
          "[id^='Filter-filter.p.m.properties.Price-Check-mobile-']"
        ).length;
        let priceMin = parseInt(checkbox.dataset.min);
        let priceMax = parseInt(checkbox.dataset.max);
        let actualPriceMin = parseInt(
          this.querySelector("#Mobile-Filter-Price-GTE").value
        );
        let actualPriceMax = parseInt(
          this.querySelector("#Mobile-Filter-Price-LTE").value
        );
        if (checkbox.checked) {
          let isAdjacent = false;
          priceCheckboxes = this.querySelectorAll(".mobile-facets__checkbox");
          priceCheckboxes.forEach((c) => {
            if (c != checkbox) {
              if (
                c.checked === true &&
                (parseInt(c.dataset.min) == priceMax + 1 ||
                  parseInt(c.dataset.max) == priceMin - 1)
              ) {
                isAdjacent = true;
              }
            }
          });
          priceCheckboxes.forEach((c) => {
            if (isAdjacent === false) {
              if (c != checkbox) {
                c.checked = false;
              }
            } else {
              if (c.checked === true) {
                if (parseInt(c.dataset.min) < priceMin) {
                  priceMin = parseInt(c.dataset.min);
                }
                if (parseInt(c.dataset.max) > priceMax) {
                  priceMax = parseInt(c.dataset.max);
                }
              }
            }
          });
          if (
            checkbox.id ===
            `Filter-filter.p.m.properties.Price-Check-mobile-${totalCheck}` &&
            checkbox.checked
          ) {
            priceMax = parseInt(
              this.querySelector("#Mobile-Filter-Price-LTE").getAttribute("max")
            );
          }
          this.setPriceSlider(priceMin, priceMax);
        } else {
          if (
            checkbox.id === `Filter-filter.p.m.properties.Price-Check-mobile-1`
          ) {
            if (priceMax < actualPriceMax) {
              this.setPriceSlider(priceMax + 1, actualPriceMax);
            } else if (priceMax === actualPriceMax) {
              this.setPriceSlider(
                0,
                parseInt(
                  this.querySelector("#Mobile-Filter-Price-LTE").getAttribute(
                    "max"
                  )
                )
              );
            }
          } else if (
            checkbox.id ===
            `Filter-filter.p.m.properties.Price-Check-mobile-${totalCheck}`
          ) {
            if (priceMin > actualPriceMin) {
              this.setPriceSlider(actualPriceMin, priceMin - 1);
            } else if (priceMin === actualPriceMin) {
              this.setPriceSlider(
                0,
                parseInt(
                  this.querySelector("#Mobile-Filter-Price-LTE").getAttribute(
                    "max"
                  )
                )
              );
            }
          } else if (priceMin > actualPriceMin && priceMax === actualPriceMax) {
            this.setPriceSlider(actualPriceMin, priceMin - 1);
          } else if (priceMin > actualPriceMin && priceMax < actualPriceMax) {
            priceCheckboxes = this.querySelectorAll(".mobile-facets__checkbox");
            priceCheckboxes.forEach((c) => {
              if (c != checkbox) {
                c.checked = false;
              } else {
                c.checked = true;
              }
            });
            this.setPriceSlider(priceMin, priceMax);
          } else if (priceMin === actualPriceMin && priceMax < actualPriceMax) {
            this.setPriceSlider(priceMax + 1, actualPriceMax);
          } else if (
            priceMin === actualPriceMin &&
            priceMax === actualPriceMax
          ) {
            this.setPriceSlider(
              0,
              parseInt(
                this.querySelector("#Mobile-Filter-Price-LTE").getAttribute(
                  "max"
                )
              )
            );
          }
        }
      });
    });
  }
  setPriceSlider(priceMin, priceMax) {
    this.checkRange(
      priceMin,
      priceMax,
      "min",
      this.querySelectorAll(".facets__price .price-inputs input"),
      this.querySelectorAll(".facets__price .range-input input"),
      this.querySelectorAll(
        ".facets__price .price-slider-connects .price-slider-connect"
      )
    );
    this.checkRange(
      priceMin,
      priceMax,
      "max",
      this.querySelectorAll(".facets__price .price-inputs input"),
      this.querySelectorAll(".facets__price .range-input input"),
      this.querySelectorAll(
        ".facets__price .price-slider-connects .price-slider-connect"
      )
    );
  }
  initializeSlider() {
    const e = this.querySelectorAll(".facets__price .range-input input"),
      t = this.querySelectorAll(".facets__price .price-inputs input"),
      r = this.querySelectorAll(
        ".facets__price .price-slider-connects .price-slider-connect"
      );
    t &&
      (t.forEach((i) => {
        i.addEventListener("input", (i) => {
          const a = parseInt(t[0].value),
            s = parseInt(t[1].value);
          this.checkRange(a, s, i.target.className, t, e, r);
        });
      }),
        this.checkPrevVal(t, e, r)),
      e &&
      e.forEach((i) => {
        i.addEventListener("input", (i) => {
          const a = parseInt(e[0].value),
            s = parseInt(e[1].value);
          this.checkRange(a, s, i.target.className, t, e, r);
        });
      });
  }
  checkPrevVal(e, t, r) {
    if (e[0] && e[1]) {
      const i = parseInt(e[0].value),
        a = parseInt(e[1].value);
      0 !== i && this.checkRange(i, a, "min", e, t, r),
        a !== e[0].max && this.checkRange(i, a, "max", e, t, r);
    }
  }
  setRange(e, t, r, i, a) {
    "right" == e
      ? ((a[0].style.right = 100 - (r / i[1].max) * 100 + "%"),
        t > i[0].min
          ? (a[0].style.width =
            (r / i[1].max) * 100 - (t / i[0].max) * 100 + "%")
          : (a[0].style.width = (r / i[1].max) * 100 + "%"))
      : ((a[0].style.left = (t / i[0].max) * 100 + "%"),
        (a[0].style.width = 100 - (t / i[0].max) * 100 + "%"),
        r < i[1].max
          ? (a[0].style.width =
            (r / i[1].max) * 100 - (t / i[0].max) * 100 + "%")
          : (a[0].style.width = 100 - (t / i[0].max) * 100 + "%"));
    const priceCheckboxes = this.querySelectorAll(".mobile-facets__checkbox");
    priceCheckboxes.forEach((c) => {
      if (c.dataset.min >= t && c.dataset.max <= r) {
        c.checked = true;
      } else {
        c.checked = false;
      }
    });
  }
  checkRange(e, t, r, i, a, s) {
    (i[0].value = e),
      (i[1].value = t),
      (a[0].value = e),
      (a[1].value = t),
      r.includes("min")
        ? this.setRange("left", e, t, a, s)
        : this.setRange("right", e, t, a, s);
  }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector("a");
    e.setAttribute("role", "button"),
      e.addEventListener("click", this.closeFilter.bind(this)),
      e.addEventListener("keyup", (e) => {
        e.preventDefault(),
          "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
      });
  }
  closeFilter(e) {
    e.preventDefault(),
      (
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form")
      ).onActiveFilterClick(e);
  }
}
customElements.define("facet-remove", FacetRemove);
